import React from 'react';
import PropTypes from 'prop-types';
import { withRouter } from 'react-router';
import Intro from 'components/common/Intro';
import Select from 'components/common/Select';
import MapLegend from 'components/country-profiles/MapLegend';
import D3Map from 'components/common/map';
import LoadingSpinner from 'components/common/LoadingSpinner';
import Footer from 'components/common/Footer';

import { LEGEND_VALUES } from 'constants/countryProfile';
import { COUNTRIES_ISO_MAPPING } from 'constants/data';
class CountryPage extends React.Component {
  constructor(props) {
    super(props);
    this.notFoundIsoArr = [];
  }
  componentWillMount() {
    this.props.getCountries();
  }

  handleCountrySelect(value) {
    const route = `/country-profiles/${value}`;
    this.props.router.push(route);
  }
  optionRenderer({ label, value }) {
    const textStyles = {
      whiteSpace: 'nowrap',
      overflow: 'hidden',
      textOverflow: 'ellipsis',
      flexWrap: 'wrap', wordWrap: 'break-word',
      flex: 1
    };
    const countryIsoData = COUNTRIES_ISO_MAPPING[value];
    let alpha2Iso = null;
    if (countryIsoData) {
      alpha2Iso = countryIsoData['alpha-2'];
    }
    return (
      <div style={{ display: 'flex', width: '100%' }}>

          {value && value.length > 1 && (
            <div style={{ width: '50px', height: '15px' }}>
           {alpha2Iso && <img
             src={`https://raw.githubusercontent.com/younginnovations/country-flags/master/png250px/${alpha2Iso
                .toLowerCase()}.png`}
             onError={() => {}}
             style={{ width: 'auto', height: '100%' }}
             alt="country-flag"
           />}
            </div>
          )}

        <div style={textStyles}>
          <span>
          {label}</span>
        </div>
      </div>
    );
  }
  render() {
    const selectDefault = [{ value: '', label: 'Select a country' }];
    const { countries } = this.props;
    const countriesData = countries.map(c => {
      let result = {};
      result = {
        value: c.iso,
        label: c.name
      };
      return result;
    });
    const selectOpts = selectDefault.concat(countriesData);
    const isoKeys = this.props.mapCountries ? Object.keys(this.props.mapCountries) : [];
    const latestYear = isoKeys.length
    ? this.props.mapCountries[isoKeys[0]].latestYear
    : undefined;
    return (
      <div className="l-main position-relative">
        <Intro section="country-profile">
          <div className="row">
            <div className="column small-12 medium-6">
              <h1 className="title -section-title -light">Country profiles</h1>
              <p className="-light">
                {`Read individual profiles for the countries included in the
                 Resource Governance Index, to discover the country context, 
                 top-level results and in-depth analysis of extractives governance performance`}
              </p>
            </div>
            <div className="column small-12 medium-6">
            </div>
          </div>
        </Intro>
        <div className="map-container">
          <div className="row">
            <div className="column small-12 medium-6 medium-offset-3">
              <div className="c-row">
                <Select
                  clearable={false}
                  autosize={false}
                  value="select-country"
                  options={selectOpts}
                  className="-country-selector"
                  placeholder="Select country"
                  optionRenderer={this.optionRenderer}
                  showFlags
                  onChange={(option) => this.handleCountrySelect(option.value)}
                />
              </div>
            </div>
          </div>
          <div className="row relative">
            <div className="column small-12">
              {!Object.keys(this.props.mapCountries).length ?
                <LoadingSpinner /> :
                <D3Map mapCountries={this.props.mapCountries} yearOfData={2017} />}
              <MapLegend titleYear={latestYear} data={LEGEND_VALUES} />
            </div>
          </div>
        </div>
        <Footer />
      </div>
    );
  }
}

CountryPage.propTypes = {
  router: PropTypes.object,
  getCountries: PropTypes.func.isRequired,
  countries: PropTypes.array.isRequired,
  mapCountries: PropTypes.object.isRequired,
  totalAssestments: PropTypes.number
};

export default withRouter(CountryPage);



// WEBPACK FOOTER //
// ./app/components/country-profiles/index/index.jsx